import { render } from "./ListePrepaidAccountPage.vue?vue&type=template&id=1ec3765c&ts=true"
import script from "./ListePrepaidAccountPage.vue?vue&type=script&lang=ts"
export * from "./ListePrepaidAccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__